import './App.css';
import Dictionary from "./Dictionary"


function App() {
  return (
    <div className="App">
        <Dictionary defaultWordEn={"Light"} defaultWordPt={"Sol"}/>
        
    </div>
  );
}

export default App;
